import eUkraineRegular from '../fonts/e-Ukraine-Regular.woff2';
import eUkraineHead from '../fonts/e-UkraineHead-Regular.woff2';
import eUkraineLight from '../fonts/e-Ukraine-Light.woff2';
import robotoMonoRegular from '../fonts/RobotoMono-Regular.woff2';

export const eUkraineRegularFont = {
  fontFamily: 'e-Ukraine-Regular',
  fontStyle: 'normal',
  fontWeight: 400,
  src: `
    url(${eUkraineRegular}) format('woff2')
  `,
};

export const eUkraineHeadFont = {
  fontFamily: 'e-Ukraine-Head',
  fontStyle: 'normal',
  fontWeight: 400,
  src: `
    url(${eUkraineHead}) format('woff2')
  `,
};

export const eUkraineLightFont = {
  fontFamily: 'e-Ukraine-Light',
  fontStyle: 'normal',
  fontWeight: 400,
  src: `
    url(${eUkraineLight}) format('woff2')
  `,
};

export const robotoMonoRegularFont = {
  fontFamily: 'RobotoMono-Regular',
  fontStyle: 'normal',
  fontWeight: 400,
  src: `
    url(${robotoMonoRegular}) format('woff2')
  `,
};
